import { useQuery } from "react-query";
import { getVendorLeasdEquipmentById } from "../../../../actions/CarrierAgreementMgmt/Vendor";

const useGetVendorLeasedEquipment = (searchInputsData) => {
  return useQuery(
    ["GetVendorLeasedEquipment"],
    () => getVendorLeasdEquipmentById(searchInputsData),
    {
      refetchOnWindowFocus: false,
    }
  );
};
export default useGetVendorLeasedEquipment;
